import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DndContext, PointerSensor, useSensor, useSensors, useDraggable, useDroppable } from '@dnd-kit/core';
import { TaskCard } from './TaskCard.js';
/** Pure handler — exported for unit testing. */
export function handleDragEnd(onMove) {
    return (e) => {
        if (!e.over)
            return;
        const taskId = Number(e.active.id);
        const newStatus = String(e.over.id).replace('col-', '');
        if (Number.isNaN(taskId))
            return;
        onMove(taskId, newStatus);
    };
}
export function KanbanBoard({ tasks, columns, onMove }) {
    const sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: { distance: 0 },
    }));
    return (_jsx(DndContext, { sensors: sensors, onDragEnd: handleDragEnd(onMove), children: _jsx("div", { className: "grid grid-cols-5 gap-3", children: columns.map((c) => (_jsx(Column, { status: c, tasks: tasks.filter((t) => t.status === c) }, c))) }) }));
}
function Column({ status, tasks }) {
    const { setNodeRef } = useDroppable({ id: `col-${status}` });
    return (_jsxs("div", { ref: setNodeRef, "data-testid": `col-${status}`, className: "bg-slate-100 rounded p-2 min-h-[400px]", children: [_jsx("h3", { className: "font-bold mb-2 text-sm", children: status }), tasks.map((t) => _jsx(DraggableCard, { task: t }, t.id))] }));
}
function DraggableCard({ task }) {
    const { attributes, listeners, setNodeRef, transform } = useDraggable({ id: task.id });
    const style = transform
        ? { transform: `translate3d(${transform.x}px, ${transform.y}px, 0)` }
        : undefined;
    return (_jsx("div", { ref: setNodeRef, style: style, ...listeners, ...attributes, className: "mb-2", children: _jsx(TaskCard, { task: task }) }));
}
